import { type ComponentProps, useState } from "react";
import { Sheet, useSheet } from "@tamagui/sheet";
import { YStack } from "./Stacks";
type SheetBackdropProps = Omit<ComponentProps<typeof Sheet.Overlay>, "opacity" | "enterStyle" | "exitStyle" | "transition" | "children">;

/**
 * A sheet's dim, faded in only once laid out: an `enterStyle` fade can paint
 * its first native frame fully opaque. `Sheet.Overlay`'s props type has no
 * `onLayout`, so a filler child measures. The filler child remounts on every
 * open because a sheet reopened mid-exit reuses the overlay, which would not lay
 * out again.
 */
export const SheetBackdrop = (props: SheetBackdropProps) => {
  const {
    open
  } = useSheet();
  const [shown, setShown] = useState(false);
  const [wasOpen, setWasOpen] = useState(open);
  const [opens, setOpens] = useState(0);
  if (open !== wasOpen) {
    setWasOpen(open);
    if (open) {
      setOpens(count => count + 1);
    }
  }
  // The overlay fading out is the one rendered while open, so a sheet that
  // collapses on close can still report a layout and set this.
  if (!open && shown) {
    setShown(false);
  }
  return <Sheet.Overlay {...props} opacity={shown ? 1 : 0} exitStyle={{
    opacity: 0
  }} transition="backdrop" data-sentry-element="Sheet.Overlay" data-sentry-component="SheetBackdrop" data-sentry-source-file="SheetBackdrop.tsx">
      <YStack key={opens} flex={1} pointerEvents="none" onLayout={() => {
      if (open) {
        setShown(true);
      }
    }} data-sentry-element="YStack" data-sentry-source-file="SheetBackdrop.tsx" />
    </Sheet.Overlay>;
};